export const SET_FIELD_TYPES = 'SET_FIELD_TYPES';
export const SET_FIELD_TYPE = 'SET_FIELD_TYPE';
export const ADD_FIELD_TYPE = 'ADD_FIELD_TYPE';
export const UPDATE_FIELD_TYPE = 'UPDATE_FIELD_TYPE';
export const REMOVE_FIELD_TYPE = 'REMOVE_FIELD_TYPE';
export const CLEAR_FIELD_TYPE = 'CLEAR_FIELD_TYPE';
export const CLEAR_FIELD_TYPES = 'CLEAR_FIELD_TYPES';
